var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0740aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012f85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f02c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e72c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78c1f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67b1e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7e14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7df3e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.333333h16v6.095238h-16z",
    fill: "url(#c)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v5.333333h-16z",
    fill: "url(#d)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 7.61904762 5.71428571-7.61904762 5.71428569z",
    fill: "url(#a)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.14285714 5.33333333v-1.13817178c0-.42250312.33393532-.76659012.75839161-.76659012h1.53083584c.41995085 0 .7583916.34838894.7583916.76659012v1.13817178c0 .64348149-.29279634 1.10219577-.76456664 1.36953226-.27260499.15447616-.53897303.21662871-.78458346.22962399-.19492927-.01299528-.46129732-.07514783-.73390231-.22962399-.47177029-.26733649-.76456664-.72605077-.76456664-1.36953226z",
    fill: "url(#e)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.52380952 5.33333333v-1.13817178c0-.21298185.16438294-.38563774.37743923-.38563774h1.53083584c.20845392 0 .37743922.17684849.37743922.38563774v1.13817178c0 1.14285715-1.14285714 1.21904762-1.14285714 1.21904762s-1.14285715-.07619047-1.14285715-1.21904762z",
    fill: "url(#f)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.28571429 4.95238095.38095238-.38095238.38095238.38095238v.76190476h-.76190476z",
    fill: "#fff",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.76287478 7.13753624c.46144471.53179664 1.1884906.86246376 1.90379189.86246376.72229882 0 1.45927907-.3413725 1.92078389-.88504558.1361557-.16039745.11650389-.40080128-.04389355-.53695698s-.40080127-.11650389-.53695697.04389355c-.31679576.37319943-.8414126.61620425-1.33993337.61620425-.49482969 0-1.01181432-.23512937-1.32832575-.59989615-.13788814-.15891059-.37849105-.17595264-.53740164-.03806449-.15891059.13788814-.17595264.37849105-.0380645.53740164z",
    fill: "#f9d835",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.666667,
    cy: 3.428571,
    fill: "url(#g)",
    mask: "url(#h)",
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSx);
export default __webpack_public_path__ + "static/media/SX.abe927b9eee222b8aa125350a5ec740c.svg";
export { ForwardRef as ReactComponent };